import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import {
  CTA_UNLOCK_YOUR_OFFER,
  DISCLAIMER_CONSULTATION_CANCEL,
} from 'consts/copy';
import { LOCAL_COLORS } from 'styles/constants';

import { SIMPLE_HERO_LAYOUT, type SimpleHeroProps } from '../SimpleHero';

export const SIMPLE_HERO_RETAIL_OFFER_CONTENT: SimpleHeroProps = {
  header: 'Take your skin to the next level',
  body: 'Get a skincare formula personalized by experts for clinically proven results.',
  efficacyStats: true,
  ctaButton: {
    buttonText: CTA_UNLOCK_YOUR_OFFER,
    disclaimerText: DISCLAIMER_CONSULTATION_CANCEL,
  },
  media: (
    <StaticImage
      src="../images/headerRetailOffer@2x.jpg"
      alt="Curology custom formula"
      loading="eager"
      width={640}
    />
  ),
  layout: SIMPLE_HERO_LAYOUT.imageLast,
  backgroundColor: LOCAL_COLORS.surfaceLight,
};
